import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`Learn | Create | Educate`}</h4>
    <ul>
      <li parentName="ul">{`Student of Computer Science and Engineering at Techno India University, West Bengal`}</li>
      <li parentName="ul">{`Full Stack Web Developer, Graphics Designer, Video Editor`}</li>
      <li parentName="ul">{`Trying to Make Web Pages and Websites`}</li>
      <li parentName="ul">{`Learning Backend Web Development`}</li>
      <li parentName="ul">{`Strugling with Computer Graphics `}</li>
      <li parentName="ul">{`Loves to see Web series and Movies. Fan of Iron-Man.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      